import Vue from 'vue'
import VueRouter from 'vue-router'

import store from '@/vuex/store'
import auth from '@/utils/auth'

Vue.use(VueRouter)

// Tratamento global para evitar uncaught error em navegacoes redundantes (Vue Router 3.1+)
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject)
  }
  return originalPush.call(this, location).catch(err => {
    if (VueRouter.isNavigationFailure(err, VueRouter.NavigationFailureType.duplicated)) {
      return err
    }
    return Promise.reject(err)
  })
}

const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace (location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalReplace.call(this, location, onResolve, onReject)
  }
  return originalReplace.call(this, location).catch(err => {
    if (VueRouter.isNavigationFailure(err, VueRouter.NavigationFailureType.duplicated)) {
      return err
    }
    return Promise.reject(err)
  })
}

const Home = () => import('@/components/home/home')
const Ajuda = () => import('@/components/ajuda/ajuda')
const Usuario = () => import('@/components/usuario/usuario')
const ConfiguracoesUsuario = () => import('@/components/usuario/configuracoes')
const Autuacao = () => import('@/components/autuacao/autuacao')
const EdicaoAutuacao = () => import('@/components/autuacao/autuacao-form')
const Administracao = () => import('@/components/administracao/administracao')
const EdicaoGlossario = () => import('@/components/administracao/edicao-glossario/edicao-glossario')
const ReencaminhamentoDocumento = () => import('@/components/administracao/reencaminhamento-documento/reencaminhamento-documento')
const CaixaPostal = () => import('@/components/caixa-postal/caixa-postal')
const Documento = () => import('@/components/documento/documento')
const InformacoesDocumento = () => import('@/components/documento/informacoes-documento')
const Tramitacoes = () => import('@/components/tramitacoes/tramitacoes')
const Pecas = () => import('@/components/pecas/pecas')
const PecasTabela = () => import('@/components/pecas/pecas-tabela')
const PecasUpload = () => import('@/components/pecas/pecas-upload')
const VinculosDocumento = () => import('@/components/vinculos/vinculos-documento')
const BuscaDocumentos = () => import('@/components/busca-documentos/busca-documentos')
const NovaTramitacao = () => import('@/components/tramitacoes/tramitacao-nova')
const PageNotFound = () => import('@/components/404/404')
const Juntada = () => import('@/components/juntada/juntada')
const Relatorios = () => import('@/components/relatorios/relatorios')
const RelatorioGuiaRemessaMalote = () => import('@/components/relatorios/relatorio-guia-remessa-malote')
const RelatorioDocumentosDesarquivadosSetor = () => import('@/components/relatorios/relatorio-documentos-desarquivados-setor')
const DocumentosFavoritos = () => import('@/components/documentos-favoritos/documentos-favoritos')
const EdicaoTipoDocumental = () => import('@/components/administracao/edicao-tipo-documental/edicao-tipo-documental')
const ArquivosAssinados = () => import('@/components/arquivos-assinados/arquivos-assinados')
const Consolidacao = () => import('@/components/consolidacao/consolidacao')

const router = new VueRouter({
  routes: [
    {
      path: '*',
      redirect: {name: '404'}
    },
    {
      path: '/',
      redirect: {name: 'Home'}
    },
    {
      path: '/home',
      name: 'Home',
      component: Home
    },
    {
      path: '/autuacoes',
      component: Autuacao,
      meta: { requiresAuth: true },
      children: [
        {
          path: '',
          name: 'NovaAutuacao',
          component: EdicaoAutuacao
        },
        {
          path: ':idDocumento',
          name: 'EdicaoAutuacao',
          component: EdicaoAutuacao,
          props: (route) => ({idDocumento: route.params.idDocumento})
        }
      ]
    },
    {
      path: '/administracao',
      component: Administracao,
      meta: { requiresAuth: true },
      children: [
        {
          path: 'edicao-de-vocabulario-controlado',
          name: 'EdicaoGlossario',
          component: EdicaoGlossario
        },
        {
          path: 'reencaminhamento-de-documento',
          name: 'ReencaminhamentoDocumento',
          component: ReencaminhamentoDocumento
        },
        {
          path: 'edicao-tipo-documental',
          name: 'EdicaoTipoDocumental',
          component: EdicaoTipoDocumental
        }
      ]
    },
    {
      path: '/busca',
      name: 'BuscaDocumentos',
      component: BuscaDocumentos,
      props: (route) => ({ query: route.query })
    },
    {
      path: '/caixa-postal',
      name: 'CaixaPostal',
      component: CaixaPostal,
      meta: { requiresAuth: true }
    },
    {
      path: '/relatorios',
      component: Relatorios,
      meta: { requiresAuth: true },
      children: [
        {
          path: 'malote',
          name: 'RelatorioGuiaRemessaMalote',
          component: RelatorioGuiaRemessaMalote,
          meta: { requiresAuth: true }
        },
        {
          path: 'documentos-desarquivados',
          name: 'RelatorioDocumentosDesarquivadosSetor',
          component: RelatorioDocumentosDesarquivadosSetor,
          meta: { requiresAuth: true }
        }
      ]
    },
    {
      path: '/ajuda',
      name: 'Ajuda',
      component: Ajuda
    },
    {
      path: '/documentos/:documentId',
      component: Documento,
      props: (route) => ({documentId: route.params.documentId}),
      children:
      [
        {
          path: '',
          name: 'InformacoesDocumento',
          component: InformacoesDocumento
        },
        {
          path: 'juntada',
          name: 'Juntada',
          component: Juntada,
          meta: { requiresAuth: true }
        },
        {
          path: 'tramitacoes',
          name: 'Tramitacoes',
          component: Tramitacoes
        },
        {
          path: 'pecas',
          component: Pecas,
          children: [
            {
              path: '',
              name: 'PecasTabela',
              component: PecasTabela
            },
            {
              path: 'upload',
              name: 'PecasUpload',
              component: PecasUpload,
              meta: { requiresAuth: true }
            }
          ]
        },
        {
          path: 'vinculos',
          name: 'VinculosDocumento',
          component: VinculosDocumento
        },
        {
          path: 'tramitar',
          name: 'Tramitar',
          component: NovaTramitacao,
          meta: { requiresAuth: true }
        }
      ]
    },
    {
      path: '/usuario',
      component: Usuario,
      meta: { requiresAuth: true },
      children: [
        {
          path: '',
          name: 'ConfiguracoesUsuario',
          component: ConfiguracoesUsuario,
          meta: { requiresAuth: true }
        }
      ]
    },
    {
      path: '/404',
      name: '404',
      component: PageNotFound
    },
    {
      path: '/documentos-favoritos',
      name: 'DocumentosFavoritos',
      component: DocumentosFavoritos,
      meta: { requiresAuth: true }
    },
    {
      path: '/arquivos-assinados',
      name: 'ArquivosAssinados',
      component: ArquivosAssinados,
      meta: { requiresAuth: true }
    },
    {
      path: '/consolidacao',
      name: 'Consolidacao',
      component: Consolidacao
    }
  ]
})

router.beforeEach(async (to, from, next) => {
  // Autenticar o usuário
  try {
    const responseAuth = await auth.getAutenticacaoUsuario()
    const responsePermissoes = await auth.getPermissoesUsuario()
    const responseConfiguracoes = await auth.getConfiguracoesUsuario()
    store.dispatch('auth/SET_USUARIO', { dadosAuth: responseAuth, dadosPermissoes: responsePermissoes, dadosConfiguracoes: responseConfiguracoes })
    next()
  } catch (error) {
    store.dispatch('auth/SET_USUARIO', { })
    if (to.matched.some(record => record.meta.requiresAuth)) {
      window.location.replace(`${process.env.API_BASE_URL}web`)
    } else {
      next()
    }
  }
})

export default router
